import "./SelfServe.css";
import "react-hook-theme/dist/styles/style.css";
import React, { useEffect, useState, lazy, Suspense } from "react";
import { Box, Grid, Divider, Button } from "@mui/material";
import PropTypes from 'prop-types';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// import { HiPlus, HiMinus } from "react-icons/hi";
import FwSymbol from '../../media/site_media/illustrations/withme/grey-logo.png';
import axios from 'axios';
import Modal from "@mui/material/Modal";
import CircularProgress from '@mui/material/CircularProgress';
import { FcGoogle } from "react-icons/fc";
import { logApiRequest } from '../common/mixpanelInterface';
import { Helmet } from 'react-helmet';
import "../../css/Influencer.css";
import { FaApple } from "react-icons/fa";
import AndroidPlaystore from '../../media/site_media/social_icons/play-store.png';
import AppleAppstore from '../../media/site_media/social_icons/apple-store.png';
// import LazyImage from '../common/LazyImage';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { useSearchParams } from "react-router-dom";
import "swiper/css/free-mode";
import { gtag, install } from 'ga-gtag';
import { enableRB2B } from '../../lib/rb2bContainer';
import { useDebouncedResize } from '../../hooks/useDebouncedResize';
import { useIdle } from '../../hooks/useIdle';
import LazySection from '../common/LazySection';
import Hero from "./SalesPageComponents/Hero"; // keep LCP-critical hero direct
import PreloadHeroMockup from '../../media/site_media/sales_page/HandMockupCompressed.webp';
import FeaturesBreakdown from "./SalesPageComponents/FeaturesBreakdown";
// import SliderFeatures from "./SalesPageComponents/SliderFeatures";
// import BentoBoxFeatures from "./SalesPageComponents/BentoBoxFeatures";
import PreloadHeroBg from '../../media/site_media/sales_page/BackgroundGradientCompressed.webp';
// import BentoGridFeatures from "./SalesPageComponents/BentoGridFeatures";
import waitUntilConditionIsTrue from '../../utils/waitUntilConditionIsTrue';
const OnboardingNavbar = lazy(() => import("../Navigation/OnboardingNavbar"));

const PopupModal = lazy(() => import('react-calendly').then(module => ({ default: module.PopupModal })));
const PricingModal = lazy(() => import('./PricingModal'));
// const AppModal = lazy(() => import('./AppModal'));
const AppleLogin = lazy(() => import('react-apple-login'));
const Footer = lazy(() => import("../Navigation/Footer"));

// Components
const PartnerSlider = lazy(() => import("./SalesPageComponents/PartnerSlider"));
const CreatorSuccess = lazy(() => import("./SalesPageComponents/CreatorSuccess"));
const ToolsLayout = lazy(() => import("./SalesPageComponents/ToolsLayout"));
const Features = lazy(() => import("./SalesPageComponents/Features"));
// const FeaturesGrid = lazy(() => import("./SalesPageComponents/FeaturesGrid"));
const InformationBar = lazy(() => import("./SalesPageComponents/InformationBar"));
const CallToActionSegment = lazy(() => import("./SalesPageComponents/CallToActionSegment"));
const BasicPricing = lazy(() => import("./SalesPageComponents/BasicPricing"));
const PricingComparison = lazy(() => import("./SalesPageComponents/PricingComparison"));
const FAQs = lazy(() => import("./SalesPageComponents/FAQs"));

const paths = require('../../paths.json');
const INTERCOM_APP_ID = 'lfsiny3p';

const fbPixelId = '153164980996102';
const fbAccessToken = 'EAAaUbCCiyfMBO1ML5ZAf0eCFXZBjn7Lwt5f3WsFlG4j07XHcccnU59mhObqQQzHGQWsmlaNzRUZBcQKfI2ZBl3onRIzobGYGAr1u6197OWvrP2jwfnjikZC4R5Tds46G99cApvN2sbtbpIcRtafMijZA6v9GZAY5o9Bhke7Xu05zHS1SZBgRZB15BgoJVbaqs7tcOUwZDZD';


async function sendSalesPageView(ip, fbclid) {
   const apiUrl = `https://graph.facebook.com/v21.0/${fbPixelId}/events`;
   const accessToken = fbAccessToken; 
   // Get current timestamp
   const eventTime = Math.floor(Date.now() / 1000);
   // Prepare the payload
   const payload = {
      data: [
         {
            event_name: "SalesPageView",
            event_time: eventTime,
            event_source_url: window.location.href, // Current page URL
            action_source: "website",
            user_data: {
               client_ip_address: ip,
               fbc: fbclid // Added fbclid to the payload
            },
         }
      ],
      access_token: accessToken,
   };

   try {
      // Send the POST request
      const response = await fetch(apiUrl, {
         method: "POST",
         headers: {
         "Content-Type": "application/json",
         },
         body: JSON.stringify(payload),
      });
      if (response.ok) {
      } else {
      }
   } catch (error) {
   }
}

const email_cta_tagline = "Join 1000's of creators and experts who have built their business with WithMe"

const modalStyle = {
    display: 'flex',
    height: 'auto',
    // bgcolor: 'rgba(0,0,0,1)',
    minHeight: '100vh',
    minWidth: '100vw',
    overflowY: 'hidden',
    outline: 'none',
    zIndex: '9999',
};
const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    // borderBottom: 0,
    marginBottom: '15px',
    borderRadius: '7px',
    fontFamily: 'Roboto',

    '&:before': {
        display: 'none',
        fontFamily: 'Roboto',
    },
}));

if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => install('G-B48N4YEGNE'));
} else {
    setTimeout(() => install('G-B48N4YEGNE'), 2000);
}

const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
 }

function getCurrency() {
    let currency = ''
    let location = Intl.DateTimeFormat().resolvedOptions().timeZone
    // let locale = Intl.NumberFormat().resolvedOptions().locale
    if (location.indexOf('Europe') > -1) {
        // location.indexOf('London') > -1 ? currency = 'GBP' : location.indexOf('Stockholm') > -1 ? currency = 'SEK' : currency = 'EUR'
        location.indexOf('London') > -1 ? currency = 'GBP' : currency = 'USD'
    } else {
        currency = 'USD'
    }
    // } else if (
    //     (location.indexOf('America/Creston') > -1)
    //     || (location.indexOf('America/Vancouver') > -1)
    //     || (location.indexOf('America/Whitehorse') > -1)
    //     || (location.indexOf('America/Cambridge_Bay') > -1)
    //     || (location.indexOf('America/Edmonton') > -1)
    //     || (location.indexOf('America/Inuvik') > -1)
    //     || (location.indexOf('America/Regina') > -1)
    //     || (location.indexOf('America/Swift_Current') > -1)
    //     || (location.indexOf('America/Yellowknife') > -1)
    //     || (location.indexOf('America/Coral_Harbour') > -1)
    //     || (location.indexOf('America/Dawson_Creek') > -1)
    //     || (location.indexOf('America/Rainy_River') > -1)
    //     || (location.indexOf('America/Rankin_Inlet') > -1)
    //     || (location.indexOf('America/Resolute') > -1)
    //     || (location.indexOf('America/Winnipeg') > -1)
    //     || (location.indexOf('America/Blanc-Sablon') > -1)
    //     || (location.indexOf('America/Iqaluit') > -1)
    //     || (location.indexOf('America/Montreal') > -1)
    //     || (location.indexOf('America/Nipigon') > -1)
    //     || (location.indexOf('America/Pangnirtung') > -1)
    //     || (location.indexOf('America/Thunder_Bay') > -1)
    //     || (location.indexOf('America/Toronto') > -1)
    //     || (location.indexOf('America/Glace_Bay') > -1)
    //     || (location.indexOf('America/Goose_Bay') > -1)
    //     || (location.indexOf('America/Halifax') > -1)
    //     || (location.indexOf('America/Moncton') > -1)
    //     || (location.indexOf('America/St_Johns') > -1)
    // ) {
    //     currency = 'CAD'
    // } else if (location.indexOf('America') > -1) {
    //     currency = 'USD'
    // } else if (location.indexOf('Africa') > -1) {
    //     currency = 'USD'
    // } else if (
    //     (location.indexOf('Australia') > -1)
    //     || (location.indexOf('Indian/Cocos') > -1)
    //     || (location.indexOf('Indian/Christmas') > -1)
    // ) {
    //     currency = 'AUD'
    // } else if (
    //     (location.indexOf('Pacific/Auckland') > -1)
    //     || (location.indexOf('Pacific/Chatham') > -1)	
    //  ) {
    //     currency = 'NZD'
    //  } else {
    //     currency = 'GBP'
    // }
    return currency
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export default function SalesPage(props) {
    const { width: windowWidth } = useDebouncedResize();
    const isIdle = useIdle();

    useEffect(() => {
        enableRB2B();
    }, []);
    const [imageSelected, setImageSelected] = useState(0);
    const [displayName, setDisplayName] = useState('')
    const [userEmail, setUserEmail] = useState('')
    const [emailField, setEmailField] = useState('')
    const [submitError, setSubmitError] = useState(false)
    const [emailSubmit, setEmailSubmit] = useState({ open: false, severity: 'success', message: '' })
    const [expanded, setExpanded] = React.useState('panel1');
    const [load_user_data] = useState((props.load_user_data === false) ? false : true);
    const [current_user, setCurrentUser] = useState('');
    const [current_user_email, setCurrentUserEmail] = useState('');
    const [influencer_bool, setInfluencerBool] = useState('');
    const [intercom_verify_key, setIntercomVerifyKey] = useState('');
    const [hidden_influencer, setHiddenInfluencer] = useState('');
    const [waiting_list_influencer, setWaitingListInfluencer] = useState('')
    const [current_user_icon, setCurrentUserIcon] = useState('');
    const [pre_influencer, setPreInfluencer] = useState(false);
    const [logged_in, setLoggedIn] = useState(false);
    const [value] = React.useState(0);
    const [calendlyModal, setCalendlyModal] = useState(false);
    const [registerIsLoading, setRegisterIsLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [referralId, setReferralId] = useState('');
    const [referralCode, setReferralCode] = useState('');
    const [passiveReferralId, setPassiveReferralId] = useState('');
    const [user_subscriptions, setUserSubs] = useState([])
    const [n_user_subscriptions, setNUserSubs] = useState(0)
    const [utmSource, setUtmSource] = useState('');
    const [utmMedium, setUtmMedium] = useState('');
    const [utmCampaign, setUtmCampaign] = useState('');
    const [utmContent, setUtmContent] = useState('');
    const [utmTerm, setUtmTerm] = useState('');
    const [instaText] = useState('Copy link');
    const [pricingModal, setPricingModal] = useState(false)
    const [selectedCreateTool, setSelectedCreateTool] = useState(0)
    const [selectedMonetiseTool, setSelectedMonetiseTool] = useState(0)
    const [selectedGrowthTool, setSelectedGrowthTool] = useState(0)
    const [appModal, setAppModal] = useState(false)
    const [isInstagramBrowser, setIsInstagramBrowser] = useState(false)

    const handleAppModalOpen = () => {
        setAppModal(true)
    }

    const handleAppModalClose = () => {
        setAppModal(false)
    }


    // Styles
    const sectionHeader = {
        color: 'var(--brand-color)',
        fontSize: '16px',
        textTransform: 'uppercase',
        fontWeight: '800',
    }

    const mainHeader = {
        color: '#222222',
        fontSize: windowWidth < 600 ? '30px' : '38px',
        textTransform: 'uppercase',
        fontWeight: '600',
        margin: '0px',
        maxWidth: '900px',
        textAlign: 'center',
        marginBottom: '20px',
    }

    const mainDescription = {
        color: '#6E89AF',
        fontSize: windowWidth < 600 ? '14px' : '16px',
        fontWeight: '400',
        margin: '0px 0px',
        maxWidth: '900px',
        textAlign: 'center',
        marginBottom: '20px',
        lineHeight: '1.5',
    }

    const launchIntercom = React.useCallback(() => {
        const userOpts = logged_in ? {
          name: current_user,
          email: current_user_email,
          user_hash: intercom_verify_key,
          is_influencer: influencer_bool,
          is_logged_in: logged_in,
          avatar: { type: 'avatar', image_url: current_user_icon },
        } : {};
      
        if (window.deferIntercom) window.deferIntercom();
      
        (function wait() {
          if (window.Intercom && typeof window.Intercom === 'function') {
            if (!window.__intercomBooted) {
              window.Intercom('boot', {
                app_id: INTERCOM_APP_ID,
                api_base: 'https://api-iam.intercom.io',
                hide_default_launcher: true,
                ...userOpts,
              });
              window.__intercomBooted = true;
            } else if (logged_in) {
              window.Intercom('update', userOpts);
            }
            window.Intercom('show');
          } else {
            setTimeout(wait, 50);
          }
        })();
      }, [logged_in, current_user, current_user_email, intercom_verify_key, influencer_bool, current_user_icon]);

    useEffect(() => {
        if (!isIdle) return;
        
        if ((paths.URL === "https://fitwith.io/") || (paths.URL === "https://withme.so/")){
            const urlParams = new URLSearchParams(window.location.search);
            const fbclid = urlParams.get('fbclid');
            if (fbclid) {
                localStorage.setItem('fbclid', 'fb.1.' + Date.now() + '.' + fbclid);
            }
            axios.get("https://api64.ipify.org?format=json")
            .then(res => sendSalesPageView(res.data.ip, 'fb.1.' + Date.now() + '.' + fbclid))
            .catch(err => console.error("Error fetching IP:", err));
        }
    }, [isIdle, searchParams])


    // run tracking script (deferred until idle to avoid blocking LCP)
    useEffect(() => {
        if (!isIdle) return;
        
        const scriptId = 'vtag-ai-js';
        let idleHandle = null;
        const inject = () => {
            if (document.getElementById(scriptId)) return;
            const script = document.createElement('script');
            script.id = scriptId;
            script.async = true;
            script.defer = true;
            script.src = 'https://r2.leadsy.ai/tag.js';
            script.setAttribute('data-pid', '3KYmvy8u5QmXukLd');
            script.setAttribute('data-version', '062024');
            document.body.appendChild(script);
        };
        if ('requestIdleCallback' in window) {
            idleHandle = window.requestIdleCallback(inject, { timeout: 5000 });
        } else {
            // fallback after a short delay
            idleHandle = setTimeout(inject, 2500);
        }
        return () => {
            if (typeof idleHandle === 'number') clearTimeout(idleHandle);
            else if (idleHandle && window.cancelIdleCallback) window.cancelIdleCallback(idleHandle);
            const existingScript = document.getElementById(scriptId);
            if (existingScript) existingScript.remove();
        };
    }, [isIdle]);

    // get the user information
    useEffect(() => {
        try {
            const saved = localStorage.getItem("userEmail");
            const initialValue = JSON.parse(saved);
            setUserEmail(initialValue);
        } catch {
            setUserEmail('');
        }
        new Promise(async (resolve, reject) => {
            if (load_user_data === true) {
                const res = await axios({
                    method: 'get',
                    url: paths.BACKEND_URL + 'api/intercom_user_verify_extra',
                    withCredentials: true,
                })
                if (res.data) {
                    // username
                    setCurrentUser(res.data.username);
                    // diplay name
                    setDisplayName(res.data.display_name)
                    // email
                    setCurrentUserEmail(res.data.email);
                    // intercom key
                    setIntercomVerifyKey(res.data.user_key);
                    // is influencer
                    setInfluencerBool(res.data.influencer_bool);
                    // is pre influencer
                    setPreInfluencer(res.data.pre_influencer);
                    // is waitlist influencer
                    setWaitingListInfluencer(res.data.waiting_list_influencer);
                    // user icon image
                    setCurrentUserIcon(res.data.current_user_icon);
                    // hidden influencer
                    setHiddenInfluencer(res.data.hidden_influencer);
                    // user subs
                    setUserSubs(res.data.user_subscriptions);
                    // number of user subs
                    setNUserSubs(res.data.n_user_subscriptions);
                    setReferralId(searchParams.get("id"));
                    setReferralCode(searchParams.get("code"));
                    setPassiveReferralId(searchParams.get("passive_id"));
                    setUtmSource(searchParams.get("utm_source"));
                    setUtmMedium(searchParams.get("utm_medium"));
                    setUtmCampaign(searchParams.get("utm_campaign"));
                    setUtmContent(searchParams.get("utm_content"));
                    setUtmTerm(searchParams.get("utm_term"));
                    if (String(searchParams.get("creators")) === 'true') {
                        window.location.assign(window.location.href + '#creators')
                    }
                    // set logged in
                    if (res.data.username !== '') {
                        setLoggedIn(true)
                    } else {
                        setLoggedIn(false)
                    }
                }
            } else {
                setReferralId(searchParams.get("id"));
                setReferralCode(searchParams.get("code"));
                setPassiveReferralId(searchParams.get("passive_id"));
                setUtmSource(searchParams.get("utm_source"));
                setUtmMedium(searchParams.get("utm_medium"));
                setUtmCampaign(searchParams.get("utm_campaign"));
                setUtmContent(searchParams.get("utm_content"));
                setUtmTerm(searchParams.get("utm_term"));
            }
        })
    }, [load_user_data]);

    const handleCreateTabChange = (newValue) => setSelectedCreateTool(newValue);
    const handleMonetiseTabChange = (newValue) => setSelectedMonetiseTool(newValue);
    const handleGrowthTabChange = (newValue) => setSelectedGrowthTool(newValue);
    // const handleChange = (panel) => (event, newExpanded) => setExpanded(newExpanded ? panel : false);
    // const handleTabs = (event, newValue) => setValue(newValue);
    const handlePricingModalOpen = () => setPricingModal(true);
    const handlePricingModalClose = () => setPricingModal(false);


    // // Save user email input to local storage to be accessed on register page
    useEffect(() => {
        // storing input name
        localStorage.setItem("userEmail", JSON.stringify(userEmail));
    }, [userEmail]);


    const AccordionSummary = styled((props) => (
        <MuiAccordionSummary
            {...props}
        />
    ))(({ theme }) => ({
        backgroundColor:
            theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, .05)'
                : 'rgba(0, 0, 0, 0)',
        flexDirection: 'flex-end',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            // transform: 'rotate(90deg)',


        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
            fontWeight: '600',
            fontSize: '14px'
        },
    }));

    const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
        padding: theme.spacing(2),
        borderTop: '1px solid rgba(0, 0, 0, .125)',
    }));

    useEffect(() => {
        setEmailField(document.querySelectorAll('.email-field'));
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault()
        setEmailSubmit({
            open: false,
            severity: submitError ? 'error' : 'success',
            message: ''
        })
        setSubmitError(false)
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!userEmail || regex.test(userEmail) === false) {
            setEmailSubmit({
                open: true,
                severity: 'error',
                message: "Please enter a valid email address"
            })
            setSubmitError(true)
        }
        else {
            const form_data = new FormData()
            const emailRecipient = 'markgray@fitwithofficial.com'
            form_data.append('email', userEmail)
            form_data.append('recipient', emailRecipient)
            const startTime = performance.now();
            axios(
                {
                    method: 'post',
                    url: paths.BACKEND_URL + 'api/landing_page_submit_email',
                    data: form_data,
                    headers: {
                        'Content-type': 'application/json',
                    },
                    withCredentials: true
                }).then(res => {
                    // if (!res.data.error === 'email already exists') {
                    //    console.log('success')
                    //    logApiRequest(paths.BACKEND_URL + 'api/landing_page_submit_email', performance.now() - startTime)
                    // }
                    // else {
                    //    throw new Error('Email already exists')
                    // }
                    if (res.data.success) {
                        logApiRequest(paths.BACKEND_URL + 'api/landing_page_submit_email', performance.now() - startTime)
                        setEmailSubmit({
                            open: true,
                            severity: 'success',
                            message: "Done! We'll be in touch with you soon."
                        })
                        emailField[0].value = ''
                        emailField[1].value = ''
                        window.location.assign('https://fitwith.pipedrive.com/scheduler/ajvdl4sO/meeting-default')
                    }
                    else {
                        setEmailSubmit({
                            open: true,
                            severity: 'error',
                            message: "Oops. It looks like there was an error. Please try again"
                        })
                        setSubmitError(true)
                    }
                })
        }
    }

    useEffect(() => {
        const detectInstagramBrowser = async () => {
            const userAgent = navigator.userAgent;
            setIsInstagramBrowser(userAgent.includes('Instagram') || userAgent.includes('FB_IAB'));
        };
        detectInstagramBrowser();
    }, []);


    const scrollToPartners = () => {
        const partnersElement = document.getElementById('partners');
        if (partnersElement) {
            partnersElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="landing_body" style={{ overflow: 'hidden', }}>
            <Grid
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.stopPropagation();
                        e.preventDefault();
                        let direct_url = ''
                        if (logged_in === true) {
                            if (referralId != null) {
                                direct_url = '/become-a-creator/register?id=' + referralId
                            } else if (passiveReferralId != null) {
                                direct_url = '/become-a-creator/register?passive_id=' + passiveReferralId
                            } else {
                                direct_url = '/become-a-creator/register'
                            }
                            if (utmSource !== null) {
                                if (direct_url.includes('?')) {
                                    direct_url = direct_url + '&utm_source=' + utmSource
                                } else {
                                    direct_url = direct_url + '?utm_source=' + utmSource
                                }
                            }
                            if (utmMedium !== null) {
                                if (direct_url.includes('?')) {
                                    direct_url = direct_url + '&utm_medium=' + utmMedium
                                } else {
                                    direct_url = direct_url + '?utm_medium=' + utmMedium
                                }
                            }
                            if (utmCampaign !== null) {
                                if (direct_url.includes('?')) {
                                    direct_url = direct_url + '&utm_campaign=' + utmCampaign
                                } else {
                                    direct_url = direct_url + '?utm_campaign=' + utmCampaign
                                }
                            }
                            if (utmContent !== null) {
                                if (direct_url.includes('?')) {
                                    direct_url = direct_url + '&utm_content=' + utmContent
                                } else {
                                    direct_url = direct_url + '?utm_content=' + utmContent
                                }
                            }
                            if (utmTerm !== null) {
                                if (direct_url.includes('?')) {
                                    direct_url = direct_url + '&utm_term=' + utmTerm
                                } else {
                                    direct_url = direct_url + '?utm_term=' + utmTerm
                                }
                            }
                            window.location.assign(direct_url)
                        } else {
                            const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                            if (!userEmail || regex.test(userEmail) === false) {
                                setEmailSubmit({
                                    open: true,
                                    severity: 'error',
                                    message: "Please enter a valid email address"
                                })
                                setSubmitError(true);
                            } else {
                                if (referralId != null) {
                                    direct_url = '/become-a-creator/register?id=' + referralId
                                } else if (passiveReferralId != null) {
                                    direct_url = '/become-a-creator/register?passive_id=' + passiveReferralId
                                } else {
                                    direct_url = '/become-a-creator/register'
                                }
                                if (utmSource !== null) {
                                    if (direct_url.includes('?')) {
                                        direct_url = direct_url + '&utm_source=' + utmSource
                                    } else {
                                        direct_url = direct_url + '?utm_source=' + utmSource
                                    }
                                }
                                if (utmMedium !== null) {
                                    if (direct_url.includes('?')) {
                                        direct_url = direct_url + '&utm_medium=' + utmMedium
                                    } else {
                                        direct_url = direct_url + '?utm_medium=' + utmMedium
                                    }
                                }
                                if (utmCampaign !== null) {
                                    if (direct_url.includes('?')) {
                                        direct_url = direct_url + '&utm_campaign=' + utmCampaign
                                    } else {
                                        direct_url = direct_url + '?utm_campaign=' + utmCampaign
                                    }
                                }
                                if (utmContent !== null) {
                                    if (direct_url.includes('?')) {
                                        direct_url = direct_url + '&utm_content=' + utmContent
                                    } else {
                                        direct_url = direct_url + '?utm_content=' + utmContent
                                    }
                                }
                                if (utmTerm !== null) {
                                    if (direct_url.includes('?')) {
                                        direct_url = direct_url + '&utm_term=' + utmTerm
                                    } else {
                                        direct_url = direct_url + '?utm_term=' + utmTerm
                                    }
                                }
                                window.location.assign(direct_url)
                            }
                        }
                    }
                }}
            >
                <Suspense fallback={<></>}>
                    <OnboardingNavbar
                        logged_in={logged_in}
                        launchIntercom={launchIntercom}
                        current_user_icon={current_user_icon}
                        pre_influencer={pre_influencer}
                        current_user={current_user}
                        windowWidth={windowWidth}
                        handlePricingModalOpen={() => handlePricingModalOpen()}
                        handlePricingModalClose={() => handlePricingModalClose()}
                        handleAppModalOpen={() => handleAppModalOpen()}
                        handleAppModalClose={() => handleAppModalClose()}
                        displayName={displayName}
                        influencer_bool={influencer_bool}
                        hidden_influencer={hidden_influencer}
                        waiting_list_influencer={waiting_list_influencer}
                        user_subscriptions={user_subscriptions}
                        n_user_subscriptions={n_user_subscriptions}
                        setCalendlyModal={(bool) => setCalendlyModal(bool)}
                        utmSource={utmSource}
                        utmMedium={utmMedium}
                        utmCampaign={utmCampaign}
                        utmTerm={utmTerm}
                        utmContent={utmContent}
                        referralId={referralId}
                        passiveReferralId={passiveReferralId}
                        referralCode={referralCode}
                    /></Suspense>
                <Helmet>
                    <title>WithMe - All-in-One Creator Hub</title>
                    {/* Preload LCP-related hero assets */}
                    <link rel="preload" as="image" href={PreloadHeroBg} imagesrcset={`${PreloadHeroBg} 1200w`} />
                    <link rel="preload" as="image" href={PreloadHeroMockup} imagesrcset={`${PreloadHeroMockup} 800w`} fetchpriority="high" />
                </Helmet>
                {/* Hero */}

                <Hero
                    windowWidth={windowWidth}
                    mainHeader={mainHeader}
                    mainDescription={mainDescription}
                    pre_influencer={pre_influencer}
                    userEmail={userEmail}
                    setUserEmail={(e) => setUserEmail(e)}
                    handleSubmit={(e) => handleSubmit(e)}
                    emailSubmit={emailSubmit}
                    setRegisterIsLoading={(bool) => setRegisterIsLoading(bool)}
                    email_cta_tagline={email_cta_tagline}
                    isInstagramBrowser={isInstagramBrowser}
                    instaText={instaText}
                    logged_in={logged_in}
                    launchIntercom={launchIntercom}
                    handlePricingModalOpen={() => handlePricingModalOpen()}
                    handlePricingModalClose={() => handlePricingModalClose()}
                    handleAppModalOpen={() => handleAppModalOpen()}
                    handleAppModalClose={() => handleAppModalClose()}
                    displayName={displayName}
                    influencer_bool={influencer_bool}
                    hidden_influencer={hidden_influencer}
                    waiting_list_influencer={waiting_list_influencer}
                    current_user={current_user}
                    user_subscriptions={user_subscriptions}
                    n_user_subscriptions={n_user_subscriptions}
                    setCalendlyModal={(bool) => setCalendlyModal(bool)}
                    utmSource={utmSource}
                    utmMedium={utmMedium}
                    utmCampaign={utmCampaign}
                    utmTerm={utmTerm}
                    utmContent={utmContent}
                    referralId={referralId}
                    passiveReferralId={passiveReferralId}
                    referralCode={referralCode}
                    scrollToPartners={scrollToPartners}
                />


                {/* Our Partners */}
                <div id="partners"></div>  
                {/* <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '400px' }} />}> */}
                    <PartnerSlider
                        sectionHeader={sectionHeader}
                        mainHeader={mainHeader}
                        mainDescription={mainDescription}
                        windowWidth={windowWidth}
                        current_user={current_user}
                        pre_influencer={pre_influencer}
                        influencer_bool={influencer_bool}
                        logged_in={logged_in}
                    />
                {/* </LazySection> */}
                
                
                {/* FEATURES - OVERVIEW OF 4 SELLING POINTS  */}
                {/* <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '600px' }} />}>
                    <Features
                        sectionHeader={sectionHeader}
                        mainHeader={mainHeader}
                        mainDescription={mainDescription}
                        imageSelected={imageSelected}
                        setImageSelected={setImageSelected}
                        windowWidth={windowWidth}
                        pre_influencer={pre_influencer}
                        influencer_bool={influencer_bool}
                        current_user={current_user}
                    />
                </LazySection> */}


                {/* <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '500px' }} />}> */}
                    <FeaturesBreakdown
                        windowWidth={windowWidth}
                        sectionHeader={sectionHeader}
                        mainHeader={mainHeader}
                        mainDescription={mainDescription}
                        pre_influencer={pre_influencer}
                        influencer_bool={influencer_bool}
                        current_user={current_user}
                        logged_in={logged_in}
                    />
                {/* </LazySection> */}

                

                {/* Pricing Comparison */}
                {/* <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '500px' }} />}> */}
                    <PricingComparison
                        windowWidth={windowWidth}
                        mainHeader={mainHeader}
                        mainDescription={mainDescription}
                        sectionHeader={sectionHeader}
                        pre_influencer={pre_influencer}
                        influencer_bool={influencer_bool}
                        current_user={current_user}
                        logged_in={logged_in}
                    />
                {/* </LazySection> */}

                {/* Creator Success Stories */}
                {/* <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '400px' }} />}> */}
                    <CreatorSuccess
                        windowWidth={windowWidth}
                        mainHeader={mainHeader}
                        sectionHeader={sectionHeader}
                    />
                {/* </LazySection> */}


                {/* Call to Action */}
                {/* <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '300px' }} />}> */}
                    <CallToActionSegment
                        windowWidth={windowWidth}
                        mainHeader={mainHeader}
                        pre_influencer={pre_influencer}
                        current_user={current_user}
                        influencer_bool={influencer_bool}
                        logged_in={logged_in}
                    />
                {/* </LazySection> */}


                {/* Grow Nurture Support Sections */}
                {/* <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '700px' }} />}> */}
                    <ToolsLayout
                        windowWidth={windowWidth}
                        sectionHeader={sectionHeader}
                        mainHeader={mainHeader}
                        mainDescription={mainDescription}
                        selectedCreateTool={selectedCreateTool}
                        selectedMonetiseTool={selectedMonetiseTool}
                        selectedGrowthTool={selectedGrowthTool}
                        handleCreateTabChange={handleCreateTabChange}
                        handleMonetiseTabChange={handleMonetiseTabChange}
                        handleGrowthTabChange={handleGrowthTabChange}
                        pre_influencer={pre_influencer}
                        influencer_bool={influencer_bool}
                        current_user={current_user}
                        logged_in={logged_in}
                    />
                {/* </LazySection> */}

                {/* The Proof of the Pudding i.e Social proof */}
                <div id="pricing"></div>
                {/* <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '500px' }} />}> */}
                    <BasicPricing 
                        windowWidth={windowWidth} 
                        sectionHeader={sectionHeader}
                        mainHeader={mainHeader}
                        mainDescription={mainDescription}
                        currency={getCurrency()}
                        pre_influencer={pre_influencer}
                        influencer_bool={influencer_bool}
                        current_user={current_user}
                        logged_in={logged_in}
                    />
                {/* </LazySection> */}

                <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '100px' }} />}>
                    <InformationBar windowWidth={windowWidth} />
                </LazySection>

                {/* FAQ's */}
                <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '400px' }} />}>
                    <FAQs 
                        windowWidth={windowWidth}
                        sectionHeader={sectionHeader}
                        mainHeader={mainHeader}
                    />
                </LazySection>


                {
                    windowWidth >= 900 ?
                        <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '300px' }} />}>
                            <Footer
                                handleAppModalOpen={() => handleAppModalOpen()}
                                handleAppModalClose={() => handleAppModalClose()}
                                launchIntercom={launchIntercom}
                                handlePricingModalOpen={() => handlePricingModalOpen()}
                                handlePricingModalClose={() => handlePricingModalClose()}
                                />
                        </LazySection>
                        :
                        <Grid container
                            direction='row'
                            alignItems='center'
                            justifyContent='center'
                            backgroundColor='#fff'
                            style={{
                                marginLeft: '10px',
                                width: '95%',
                            }}>
                            <Grid xs={12}>
                                <Divider sx={{ width: '100%', marginBottom: '15px' }} flexItem>
                                </Divider>
                            </Grid>

                            <Grid xs={0.5}>
                            <img alt="WithMe logo" src={FwSymbol} style={{ width: 'auto', height: '22px' }} />
                            </Grid>

                            <Grid xs={11.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" disableElevation onClick={() => {
                                    // show()
                                    window.Intercom('show');
                                }}
                                    sx={{
                                        padding: '4px 10px', display: 'inline-block', marginLeft: 'auto', marginRight: '0px', borderRadius: '50px', textTransform: 'none',
                                        backgroundColor: '#fff', border: 'solid #AFBED3 1px', color: '#AFBED3', '&:hover': { backgroundColor: '#f1f1f1' }
                                    }}
                                    type="submit">
                                    <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '11px' }}>Need Help?</span>
                                </Button>
                            </Grid>
                            <Grid xs={12} style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}>
                                <div style={{ display: 'inline-block' }}>
                                    <span 
                                        className={'footer_smaller_items'}
                                        style={{ fontSize: '11px', color: '#6D89AF', cursor: 'pointer', display: 'block', marginBottom: '5px' }}
                                        onClick={() => openInNewTab('/privacy_policy')}
                                    >
                                        Privacy Policy
                                    </span>
                                    <span 
                                        className={'footer_smaller_items'} 
                                        style={{ fontSize: '11px', color: '#6D89AF', cursor: 'pointer', display: 'block', marginBottom: '5px' }}
                                        onClick={() => openInNewTab('/terms_and_conditions')}
                                    >
                                        Terms &amp; Conditions
                                    </span>
                                    <span 
                                        className={'footer_smaller_items'} 
                                        style={{ fontSize: '11px', color: '#6D89AF', cursor: 'pointer', display: 'block' }}
                                        onClick={() => openInNewTab('/cookie_policy')}
                                    >
                                        Cookie Policy
                                    </span>
                                </div>
                            </Grid>

                            <Grid xs={12}>
                                <div style={{ display: 'flex' }}>

                                    <img alt="" src={AppleAppstore}
                                        onClick={() => {
                                            // handleAppModalOpen();
                                            // gtag('event', 'appstore_apple_inquiry', {
                                            //     'event_category': 'Popup Opened',
                                            //     'event_label': 'AppStore Popup Inquiry'
                                            // });
                                            window.open('https://apps.apple.com/us/app/withme/id6477915797', '_blank');
                                            gtag('event', 'appstore_apple_redirect', {
                                                'event_category': 'IOS App Download',
                                                'event_label': 'IOS App Download'
                                            });
                                        }}
                                        style={{ width: '130px', height: 'auto', margin: '5px 10px 0px -3px', cursor: 'pointer' }}
                                    />
                                    <img alt="" src={AndroidPlaystore}
                                        onClick={() => {
                                            window.open('https://play.google.com/store/apps/details?id=com.withmeapp', '_blank');
                                            gtag('event', 'appstore_android_redirect', {
                                                'event_category': 'Android App Download',
                                                'event_label': 'Android App Download'
                                            });
                                        }}
                                        style={{ width: '130px', height: 'auto', margin: '5px 0px 0px -3px', cursor: 'pointer' }}
                                    />
                                </div>
                            </Grid>


                            <Grid xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <p style={{ fontSize: '10px', color: '#AFBED3' }}>FitWith Ltd All rights reserved {new Date().getFullYear()}</p>
                            </Grid>
                        </Grid>
                }
            </Grid>

            <Suspense fallback={<></>}>
                <PricingModal
                    salesPage={true}
                    pricingModal={pricingModal}
                    handlePricingModalClose={handlePricingModalClose}
                    sectionHeader={sectionHeader}
                    mainHeader={mainHeader}
                    mainDescription={mainDescription}
                    windowWidth={windowWidth}
                />
            </Suspense>

            {calendlyModal && (
                <Suspense fallback={<></>}>
                    <PopupModal
                        url="https://calendly.com/sdr-team-9rc/fitwith-demo"
                        onModalClose={() => setCalendlyModal(false)}
                        open={calendlyModal}
                        rootElement={document.getElementById("root")}
                    />
                </Suspense>
            )}

            {
                registerIsLoading ?
                    <Modal open={registerIsLoading}>
                        <Box style={modalStyle}
                            sx={{
                                display: 'flex', width: '100%', height: '100%',
                                margin: 'auto'
                            }}>
                            <Grid
                                container
                                spacing={0}
                                direction="column"
                                alignItems="center"
                                justifyContent="center"
                                style={{ minHeight: '90vh' }}
                            >
                                <CircularProgress sx={{
                                    color: 'var(--brand-color)',
                                }} />

                                <p style={{
                                    color: 'var(--primary-text-color)', fontSize: 'var(--medium-text)',
                                    fontWeight: '600',
                                }}>Creating your account...</p>
                            </Grid>
                        </Box>
                    </Modal>
                    :
                    <div></div>
            }
        </div>
    );
}


const SSOButtons = (props) => {
    const processAppleSSO = (token, firstName, lastName, apiUrl) => {
        const form_data = new FormData()
        form_data.append('token', token)
        const realName = `${firstName} ${lastName}`
        const displayName = `${firstName}${lastName}`
        form_data.append('real_name', realName)
        form_data.append('display_name', displayName)
        axios.post(
            apiUrl,
            form_data,
            { withCredentials: true }
        ).then(res => {
            window.location.assign(res['data']['redirect_url'])
        }).catch(() => props.setRegisterIsLoading(false))
    }
    return (
        <Grid style={props.containerStyle ? props.containerStyle : {}}>
            <Button
                style={props.googleBtnStyle}
                onClick={
                    () => {
                        props.setRegisterIsLoading(true);
                        gtag('event', 'landing_page_social_signup_lead', {
                            'event_category': 'Lead',
                            'event_label': 'Landing Page Lead (Google)'
                        });
                        let site = 'fitwith'
                        if (window.location.origin.includes('withme.so')) {
                            site = 'withme'
                        }
                        if ((props.referralId != null) & (props.referralId != '')) {
                            window.location.assign(paths.BACKEND_URL + 'oauth/login/google-oauth2?next=/api/social/confirm_profile_direct_influencer/' + props.referralId + '/null/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site)
                        } else if ((props.passiveReferralId != null) & (props.passiveReferralId != '')) {
                            window.location.assign(paths.BACKEND_URL + 'oauth/login/google-oauth2?next=/api/social/confirm_profile_passive_influencer/' + props.passiveReferralId + '/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site)
                        } else {
                            window.location.assign(paths.BACKEND_URL + 'oauth/login/google-oauth2?next=/api/social/confirm_profile_passive_influencer/null/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site)
                        }
                    }
                }
            >
                <FcGoogle size={19} style={{ marginRight: '8px' }} /> Sign up with Google
            </Button>
            <Suspense fallback={<Button style={props.appleBtnStyle}><FaApple size={19} style={{ marginRight: '8px' }} /> Sign up with Apple</Button>}>
                <AppleLogin
                    render={({ onClick }) =>
                        <Button
                            onClick={async () => {
                                window.deferApple && window.deferApple();
                                try { await waitUntilConditionIsTrue(() => window.AppleID && window.AppleID.auth); } catch {}
                                onClick();
                            }}
                            style={props.appleBtnStyle}>
                            <FaApple size={19} style={{ marginRight: '8px' }} /> Sign up with Apple
                        </Button>
                    }
                    clientId="so.withme"
                    redirectURI={`${window.location.origin}/login`}
                    responseType="code id_token"
                    responseMode="query"
                    usePopup={true}
                    scope="name email"
                    callback={(res) => {
                        if (!res['error']) {
                            props.setRegisterIsLoading(true)
                            let site = 'fitwith'
                            if (window.location.origin.includes('withme.so')) {
                                site = 'withme'
                            }
                            const token = res['authorization']['id_token']
                            let firstName = null
                            let lastName = null
                            if (res['user']) {
                                // User's email and name only returned the first time, or after unlinking in apple id settings
                                firstName = res['user']['name']['firstName']
                                lastName = res['user']['name']['lastName']
                            }
                            if ((props.referralId != null) & (props.referralId != '')) {
                                const apiUrl = paths.BACKEND_URL + 'api/social/confirm_profile_influencer_direct_apple/'
                                    + props.referralId + '/null/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site
                                processAppleSSO(token, firstName, lastName, apiUrl)
                            } else if ((props.passiveReferralId != null) & (props.passiveReferralId != '')) {
                                const apiUrl = paths.BACKEND_URL + 'api/social/confirm_profile_influencer_passive_apple/'
                                    + props.passiveReferralId + '/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site
                                processAppleSSO(token, firstName, lastName, apiUrl)
                            } else {
                                const apiUrl = paths.BACKEND_URL + 'api/social/confirm_profile_influencer_passive_apple/'
                                    + 'null' + '/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site
                                processAppleSSO(token, firstName, lastName, apiUrl)
                            }
                        }
                    }}
                />
            </Suspense>
        </Grid>
    )
}
